/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  SoftwareOnlyInitialSetupRequestDto,
  SoftwareOnlyMultiEntitySignupRequestDto,
  SoftwareOnlySignupRequestDto,
  SoftwareOnlyUserExistsRequestDto,
  UserExistenceResponse,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class SoftwareOnlyController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags software-only-controller
   * @name UserExists
   * @request POST:/api/v1/organisations/validate-email/software-only
   */
  userExists = (data: SoftwareOnlyUserExistsRequestDto, params: RequestParams = {}) =>
    this.http.request<UserExistenceResponse, any>({
      path: `/v1/organisations/validate-email/software-only`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static userExistsPath = '/v1/organisations/validate-email/software-only'
  static userExistsMethod = 'POST'
  /**
   * No description
   *
   * @tags software-only-controller
   * @name InitSaaSOnlyToDebitSwitch
   * @request POST:/api/v1/organisations/init-software-only-to-debit-switch
   */
  initSaaSOnlyToDebitSwitch = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/organisations/init-software-only-to-debit-switch`,
      method: 'POST',
      ...params,
    })

  static initSaaSOnlyToDebitSwitchPath = '/v1/organisations/init-software-only-to-debit-switch'
  static initSaaSOnlyToDebitSwitchMethod = 'POST'
  /**
   * No description
   *
   * @tags software-only-controller
   * @name CreateSoftwareOnlyOrganisation
   * @request POST:/api/v1/organisations/create/software-only
   */
  createSoftwareOnlyOrganisation = (
    data: SoftwareOnlySignupRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisations/create/software-only`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static createSoftwareOnlyOrganisationPath = '/v1/organisations/create/software-only'
  static createSoftwareOnlyOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags software-only-controller
   * @name CreateMultiEntitySoftwareOnlyOrganisation
   * @request POST:/api/v1/organisations/create/software-only/multi-entity
   */
  createMultiEntitySoftwareOnlyOrganisation = (
    data: SoftwareOnlyMultiEntitySignupRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisations/create/software-only/multi-entity`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static createMultiEntitySoftwareOnlyOrganisationPath =
    '/v1/organisations/create/software-only/multi-entity'
  static createMultiEntitySoftwareOnlyOrganisationMethod = 'POST'
  /**
   * No description
   *
   * @tags software-only-controller
   * @name SoftwareOnlyInitialSetup
   * @request PATCH:/api/v1/organisations/software-only/initial-setup
   */
  softwareOnlyInitialSetup = (
    data: SoftwareOnlyInitialSetupRequestDto,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/organisations/software-only/initial-setup`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static softwareOnlyInitialSetupPath = '/v1/organisations/software-only/initial-setup'
  static softwareOnlyInitialSetupMethod = 'PATCH'
}
